module.exports = __webpack_public_path__ + "img/emo_14.c424914f.png";